import { render, staticRenderFns } from "./pecem.vue?vue&type=template&id=52b7752d&"
import script from "./pecem.vue?vue&type=script&lang=js&"
export * from "./pecem.vue?vue&type=script&lang=js&"
import style0 from "./pecem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports